import { Component, inject } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-token-modal',
  standalone: true,
  templateUrl: './token-modal.component.html'
})
export class TokenModalComponent {
  public state = inject(AppStateService);
}
